import Root from "pages/root";
import { Heading, Container, Section, BottomSection } from "./index.styles";
import UI from "@mile-meeting/mile-ui";
import Filter from "./filters";
import { useEffect, useState } from "react";
import { getMeetingAnalyticsData, getMeetingAnalyticsMetaData } from "apis/analytics/meeting/datatable";
import { TFilter, TMeetingDataTable, TMetaData } from "types/analytics.types";
import Table from "./table";

const DataTable = () => {
  const getAdjustedDate = (unit: string, n: number): Date => {
    const date = new Date();
    if (unit === "m") {
      date.setMonth(date.getMonth() + n);
    } else {
      date.setDate(date.getDate() + n);
    }
    return date;
  };

  const [metadata, setMetadata] = useState<TMetaData[]>([]);
  const [data, setData] = useState<TMeetingDataTable[]>([]);
  const [selectedColumn, setSelectedColumn] = useState<TMetaData[]>([]);
  const [totalPage, setTotalPage] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [filter, setFilter] = useState<TFilter[]>([]);
  const [filterDate, setFilterDate] = useState<{ start: string; end: string }>({
    start: getAdjustedDate("d", -31).toDateString(),
    end: getAdjustedDate("d", -1).toDateString(),
  });

  const setMetaData = async () => {
    const res = await getMeetingAnalyticsMetaData();
    if (res.success) {
      setMetadata(res.data ?? []);
    }
  };

  const getMeetingData = async (page: number) => {
    const res = await getMeetingAnalyticsData(page, filterDate, filter);
    if (res.success) {
      setData(res.data?.meetingDashboards ?? []);
      setTotalPage(res.data?.totalPageNumber ?? 0);
      setCurrentPage(page);
    }
  };

  useEffect(() => {
    setMetaData();
  }, []);

  return (
    <Container>
      <Heading>
        <UI.Typography
          type="title03"
          fontStyle="bold"
          color="var(--alias-color-label-neutral)"
          style={{
            padding: "24px 20px",
          }}
        >
          회의실 이용 현황 데이터
        </UI.Typography>
      </Heading>
      <Section>
        <Filter
          metadata={metadata}
          onChangeColumn={setSelectedColumn}
          onChangeData={setData}
          onChangeFilter={setFilter}
          onChangeCurrentPage={setCurrentPage}
          onChangeTotalPage={setTotalPage}
          onChangeDate={(start: string, end: string) => {
            setFilterDate({ start, end });
          }}
        />
      </Section>
      <BottomSection>
        {selectedColumn.length > 0 && <Table metadata={selectedColumn} data={data} page={currentPage} />}
        {totalPage > 0 && (
          <UI.Pagination
            pageCount={totalPage}
            currentPage={currentPage}
            onChange={(page) => {
              getMeetingData(page);
            }}
          />
        )}
      </BottomSection>
    </Container>
  );
};

export default DataTable;
